import { LOGOUT, SET_USER, UPDATE_STATE } from '../../types/actions';
import { AuthAction, IAuthState } from '../../types/auth';
import { AuthState } from '../AuthContext';
import { OrganizationState } from '../organization.context';

export type OrganizationAction = { type: "updateState", payload: Partial<OrganizationState> }

export const authReducer = (
    state: AuthState,
    action: AuthAction
): AuthState => {
    switch (action.type) {
        case SET_USER:
            return {
                ...state,
                user: action.payload.user,
                userOrganization: action.payload.userOrganization ?? null,
                isLoggedIn: !!action.payload.user,
                isInitialized: true,
            };

        case LOGOUT:
            return {
                ...state,
                user: null,
                isLoggedIn: false,
                isInitialized: true,
            };

        case UPDATE_STATE:
            return { ...state, ...action.payload };

        default:
            return state;
    }
};
